import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

const styles = {
  container: {
    my: '4px',
    padding: 0,
    pl: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  avatarContainer: {
    width: '100%',
  },
  modalMargin: {
    marginBottom: '30px',
  },
  footerLabel: { fontSize: 12, fontStyle: 'italic' },
  menuContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
  },
  menuText: {
    fontSize: 12,
  },
  button: {
    padding: 0,
    height: 24,
  },
  strikeContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  strikeText: {
    fontSize: 14,
    textDecoration: 'line-through',
    marginRight: 1,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
